<template>
  <div class="bto-sb-row">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'RowComponent',
  };
</script>

<style scoped>
  .bto-sb-row {
    height: 100%;
  }
</style>
